import { BaseEntity } from '../../shared';

export class SystemSetting {
    constructor(
        public quantity: number = 0,
        public price: number = 0,
        public ratio: number = 0,
        public exchangeRate: number = 0,
        public amount: number = 0,
        public convertedAmount: number = 0,
        public number: number = 0,
        public stepToCreateInvoiceNo: number = 0,
        public signAfterApprove: boolean = false,
        public serverSign: boolean = false,
        public useSystemSettingVND: boolean = false,
    ) {
    }
}
